var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedemptionrequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29303 1.83792C2.29303 1.93792 2.29303 2.03792 2.29303 2.03792C2.29303 2.43792 2.59303 2.73792 2.99303 2.73792C3.29303 2.73792 3.49303 2.53792 3.59303 2.23792L3.79313 1.73792L9.39313 4.03792L5.49313 6.73792C5.09313 7.03792 5.09313 7.43792 5.19313 7.83792L6.09313 9.93792L4.79313 13.8379C4.59313 14.3379 4.99313 14.7379 5.39313 14.7379C5.69313 14.7379 5.89313 14.6379 5.99313 14.2379L7.39313 10.2379L7.49313 10.5379V14.0379C7.49313 14.0379 7.49313 14.7379 8.19313 14.7379C8.89313 14.7379 8.89313 14.0379 8.89313 14.0379V10.7379C8.89313 10.5379 8.89313 10.4379 8.79313 10.2379L7.39313 6.83792L10.0931 4.93792C10.2931 4.73792 10.4931 4.63792 10.4931 4.33792C10.4931 4.03792 10.2931 3.83792 10.0931 3.73792L2.89313 0.837921C2.80533 0.837921 2.77513 0.855821 2.69303 0.937921L2.29303 1.83792ZM4.39313 3.73792C3.59313 3.73792 2.89313 4.43792 2.89313 5.23792C2.89313 6.03792 3.59313 6.73792 4.39313 6.73792C5.19313 6.73792 5.89313 6.03792 5.89313 5.23792C5.89313 4.43792 5.19303 3.73792 4.39313 3.73792Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2787,
    y: 5.60956,
    width: 0.885463,
    height: 3.83712,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80286,
    y: 7.97086,
    width: 0.885463,
    height: 3.83712,
    transform: "rotate(-90 9.80286 7.97086)",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionrequest);
export default __webpack_public_path__ + "static/media/redemptionrequest.57d518d5fae1630cca795aa9caffce52.svg";
export { ForwardRef as ReactComponent };